export default __webpack_public_path__ + "static/media/solucao-04.a61097eb.webp";